import type { StylePropertiesTypes } from '@wix/document-services-types'
import type { Spx } from '@wix/thunderbolt-becky-types'

/** Internal Converters */
const customEnumConverter = (prop: StylePropertiesTypes.CustomEnum): string => {
	// The CustomEnum has a string value that needs to be converted directly
	// Based on the design description, CustomEnum values are pre-validated strings
	// that should be used as CSS values directly
	return prop.value
}

/** External Mapper */
export const customEnumConverterMap = {
	CustomEnum: customEnumConverter,
} as Record<string, (prop: StylePropertiesTypes.CustomEnum, spx?: Spx) => string>
